var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('el-card',{staticClass:"mb-20"},[_c('app-filter',{attrs:{"filter-list":_vm.table_filter,"default-label-width":"90px"},on:{"search":_vm.search}})],1),_c('el-card',[_c('app-table',{ref:"table",attrs:{"table-key":_vm.table_key,"tablep":_vm.table_params,"get-data":_vm.getOperationLogList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }